import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@freelancer/pipes';
import { UiModule } from '@freelancer/ui';
import { GiveGetReferralListModule } from '../give-get-referral-list.module';
import { GiveGetReferralListModalComponent } from './give-get-referral-list-modal.component';

@NgModule({
  imports: [CommonModule, UiModule, PipesModule, GiveGetReferralListModule],
  exports: [GiveGetReferralListModalComponent],
  declarations: [GiveGetReferralListModalComponent],
})
export class GiveGetReferralListModalModule {}
